// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3_ENA","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__9NDIS"};